import { useMediaQuery, useTheme } from "@mui/material";

// usePhone is true on the screens the desktop pages don't fit on. It reads the same
// breakpoint the layout hides its sidebar at, so the two agree on what a phone is.
export function usePhone() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down("md"));
}
